// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSingleColumn_root__2THR9","layoutWrapperMain":"LayoutSingleColumn_layoutWrapperMain__1g40a"};